export default __webpack_public_path__ + "static/media/title.c1897ea4.png";